import { Otp } from "components/Otp/Otp";
import { Dispatch } from "react";
import { Actions, ActionTypes } from "./types";

interface Props {
  token: string;
  createSessionUrl: string;
  dispatch: Dispatch<Actions>;
}

export const ExpiredOtp = ({ token, dispatch, createSessionUrl }: Props) => (
  <Otp
    createSessionUrl={createSessionUrl}
    token={token}
    onSuccess={() => {
      dispatch({ type: ActionTypes.EXPIRED_OTP_SUCCESS });
    }}
    hasContactUsLink={false}
    onBackClick={() => {
      dispatch({ type: ActionTypes.BACK });
    }}
  />
);
